/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the OpenBuyerOrderDTO interface.
 */
export function instanceOfOpenBuyerOrderDTO(value) {
    return true;
}
export function OpenBuyerOrderDTOFromJSON(json) {
    return OpenBuyerOrderDTOFromJSONTyped(json, false);
}
export function OpenBuyerOrderDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'buyerOrderId': json['buyerOrderId'] == null ? undefined : json['buyerOrderId'],
        'warehousePackageId': json['warehousePackageId'] == null ? undefined : json['warehousePackageId'],
        'externalOrderId': json['externalOrderId'] == null ? undefined : json['externalOrderId'],
        'amazonOrderId': json['amazonOrderId'] == null ? undefined : json['amazonOrderId'],
        'purchaseConfirmedAt': json['purchaseConfirmedAt'] == null ? undefined : (new Date(json['purchaseConfirmedAt'])),
        'lastCheckedAt': json['lastCheckedAt'] == null ? undefined : (new Date(json['lastCheckedAt'])),
    };
}
export function OpenBuyerOrderDTOToJSON(json) {
    return OpenBuyerOrderDTOToJSONTyped(json, false);
}
export function OpenBuyerOrderDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'buyerOrderId': value['buyerOrderId'],
        'warehousePackageId': value['warehousePackageId'],
        'externalOrderId': value['externalOrderId'],
        'amazonOrderId': value['amazonOrderId'],
        'purchaseConfirmedAt': value['purchaseConfirmedAt'] == null ? undefined : ((value['purchaseConfirmedAt']).toISOString()),
        'lastCheckedAt': value['lastCheckedAt'] == null ? undefined : ((value['lastCheckedAt']).toISOString()),
    };
}
